export default {
    title: 'Nutzer',
    id: 'ID',
    customName: 'Anzeigename',
    role_name_de: 'Rolle'
}